
export const MapStyle = {
    chiri: {key: "chiri_pale", title: "国土地理院(淡色)", menuSort: 3},
    photo: {key: "chiri_photo", title: "国土地理院(写真)", menuSort: 4},
    gaiku: {key: "gaiku", title: "街区地図", menuSort: 5},
}

export const MapLayer = {
    TreeDm: "tree_dm",
    Road: "road",
    SurveyPoint: "start_end",
    Tree: "tree",
    SelectedTree: "selected_tree",
}

export const MapSelectableLayers = [
    MapLayer.Road,
    MapLayer.SurveyPoint,
    MapLayer.TreeDm,
]

export const MapLayerTitle = {
    [MapLayer.TreeDm]: "樹木ベース",
    [MapLayer.Road]: "路線",
    [MapLayer.SurveyPoint]: "調査地点",
}

const MapDataState = {
    style: MapStyle.chiri,
    layers: null,
    center: null,
}

export default MapDataState
